import { render, staticRenderFns } from "./BuyersListModal.vue?vue&type=template&id=0c663f30&scoped=true"
import script from "./BuyersListModal.vue?vue&type=script&lang=js"
export * from "./BuyersListModal.vue?vue&type=script&lang=js"
import style0 from "./BuyersListModal.vue?vue&type=style&index=0&id=0c663f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c663f30",
  null
  
)

export default component.exports